<template>
<div class="introduction">
  <div class="title">{{$store.state.videoContent.title}}</div>
  <div class="statistic">
    <div><img src="@/assets/images/img play grey.png" /> <span>{{$store.state.videoContent.viewNumber}}</span></div>
    <div><img src="@/assets/images/img comment grey.png" /> <span>{{$store.state.videoContent.commentNumber}}</span></div>
    <div><img src="@/assets/images/img time grey.png" /> <span>{{$store.state.videoContent.duration | duration}}</span></div>
  </div>
  <div class="intro">{{$store.state.videoContent.introduction}}</div>
  <div class="courses">
    <div v-for="course in $store.state.courses" :key="course.id">
      <a class="button" :class="{active: course.id == $store.state.courseIdParam}" ref="course" @click="switchCourse(course.id)">{{course.title|maxLength(7)}}</a>
    </div>
  </div>
  <div class="operation">选集 <span>({{$store.state.videoContents.length}})</span></div>
  <div class="table">
    <div class="row" v-for="(item, index) in $store.state.videoContents" :key="item.id">
      <div class="column sn">{{index+1}}</div>
      <div class="column" style="position:relative;"><img  :src="item.coverUrl" alt="">
        <div class="freeType" @click="onClick(item.id)" v-if="item.id === $store.state.videoContent.id"><span>正在播放...</span> </div>
        <div class="freeType" v-else-if="item.freeType===3"><img src="@/assets/images/img lock whtie.png" style="min-width:16px;width:16px;height:16px"/> </div>
        <div class="freeType" @click="onClick(item.id)" v-else>点击试看</div>
      </div>
      <div class="column" style="display:flex;justify-content:space-between;flex-direction:column;margin-right:0px">
        <div class="title">{{item.title}}</div>
        <div class="stat" style="display:flex">
          <div><img src="@/assets/images/img play grey.png" /> <span>{{item.viewNumber}}</span></div>
          <div><img src="@/assets/images/img comment grey.png" /> <span>{{item.commentNumber}}</span></div>
          <div><img src="@/assets/images/img time grey.png" /> <span>{{item.starNumber}}</span></div>
        </div>
      </div>
    </div>

  </div>
</div>
</template>

<script>
// @ is an alias to /src
import axios from 'axios'
const num = function (value) {
    return value < 10 ? '0' + value : value
}
export default {
  name: 'Introduction',
  components: {},
  data() {
    return {}
  },
  mounted() {},
  filters: {
    maxLength: function(value,length){
      if(value){
        return value.substring(0,length)
      }
      return value
    },
    duration: function (value) {
      if(!value){
        return ''
      }
      let hours = 0;
      let minutes = 0;
      let seconds = 0;
      if(value > 60 * 60){
          hours = parseInt(value / 60 / 60)
          minutes = parseInt((value - hours * 60 * 60) / 60) 
          seconds = parseInt(value - hours * 60 * 60 - minutes * 60)
      }
      else if(value > 60){
          minutes = parseInt(value / 60) 
          seconds = parseInt(value - minutes * 60)
      }
      else {
          seconds = parseInt(value)
      }
      return num(hours)+ ':' +num(minutes) + ':' + num(seconds)
    }
  },
  methods: {
    async switchCourse(id) {
      this.$store.commit('setCourseIdParam', id)
      let response = await axios.get('/app/api/content/course?id=' + id)
      console.log(response)
      this.$store.commit('setVideoContents', response.data.data.videoContentVOS)
    },
    async onClick(contentId) {
      let video= await axios.get('/app/api/content/videoContent?id='+contentId)
      this.$store.commit('setVideoContent',video.data.data)
      let comment= await axios.get('/app/api/content/commentList?pageSize=1000&pageCount=1&contentType=1&id='+contentId)
      this.$store.commit('setComments',comment.data.data.data)
    }
   }
}
</script>

<style lang="scss" scoped>
.introduction {
  margin: 10px 20px;

  .title {
    font-size: 16px;
    font-weight: 600;
    color: rgba(35, 24, 21, 1);
    line-height: 22px;
  }

  .statistic {
    display: flex;
    margin-top: 12px;
    font-size: 10px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(190, 190, 190, 1);
    line-height: 14px;
    vertical-align: middle;

    >div {
      margin-right: 10px;

      img {
        vertical-align: middle;
      }

      span {
        vertical-align: middle;
      }
    }
  }

  .intro {
    margin-top: 14px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(190, 190, 190, 1);
    line-height: 17px;
    overflow-wrap: break-word;
  }

  .courses {
    margin-top: 14px;
    display: flex;
    overflow: scroll;

    a.button {
      height: 37px;
      width: 90px;
      display: inline-block;
      border: 1px solid #C9C9C9;
      background: rgba(255, 255, 255, 1);
      line-height: 37px;
      vertical-align: middle;
      box-sizing: border-box;
      border-radius: 2px;
      white-space: nowrap;
      text-align: center;
      font-size: 12px;
      font-weight: 400;
      color: rgba(35, 24, 21, 1);
      margin-right: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      overflow: hidden;
    }

    a.active {
      color: rgba(218, 72, 46, 1);
      border: 1px solid rgba(218, 72, 46, 1);
    }
  }

  .operation {
    margin-top: 14px;
    font-size: 15px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(35, 24, 21, 1);
    line-height: 22px;

    span {
      color: rgba(190, 190, 190, 1);
    }
  }

  .table {
    margin-top: 14px;

    .row {
      margin-top: 22px;
      display: flex;

      .sn {
        line-height: 77px;
        font-size: 13px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(190, 190, 190, 1);
      }

      .column {
        margin-right: 13px;
        height: 77px;

        img {
          min-width: 139px;
          width: 139px;
          height: 77px;
          border-radius: 6px;
        }

        .freeType {
          position: absolute;

          text-align: center;
          height: 24px;
          width: 60%;
          top: 0;
          bottom: 0;
          left:0;
          right: 0;
          margin: auto;
    

          padding: 3px 10px;
          background: rgba(0, 0, 0, 0.64);
          border-radius: 11px;
          border: 1px solid rgba(255, 255, 255, 1);

          font-size: 11px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          line-height: 15px;
        }

        .title {
          font-size: 15px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(35, 24, 21, 1);
        }

        .stat {
          display: flex;

          >div {
            margin-right: 10px;

            img {
              min-width: 15px;
              vertical-align: middle;
              width: 15px;
              height: 13px;
              border-radius: 0;
            }

            span {
              vertical-align: middle;
              font-size: 11px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: rgba(190, 190, 190, 1);
              line-height: 15px;
            }
          }
        }
      }
    }
  }
}
</style>
